module.exports = __webpack_public_path__ + "static/media/glamour.385f45fb.svg";